<template>
  <lb-dialog
    v-model="internalValue"
    :heading="heading"
    :width="width"
    :loading="loading"
  >
    <template v-slot:body>
      <div>
        <div>
          <div v-if="!loading && previouscycledatatoupload.length === 0" class="pa-4 grey--text text-center font-size-md">
            {{ noDataMessage }}
          </div>
          <div v-else>
            <div class="d-flex flex-column gap-3" data-testid="previous-cycle-data-dialog__body">
              <div v-if="hasSelection" class="v-note">
                <v-chip class="noTransform ru-info-chip gap-2 align-center">
                  <span><v-icon>mdi-information-outline</v-icon> Ignored which means commentary is already added in the present period hence ignored.</span>
                </v-chip>
              </div>
              <lb-datatablenew
                ref="datatable"
                :headers="headers"
                :items="tableItems"
                multiselectkey="glcode"
                :selecteditems="selectedList"
                :loading="loading"
                :enableslot="['proforma', 'forecast', 'status']"
                @selectItem="onSelectionChange"
              >
                <template #proforma="{ item }">
                  <div class="pa-2 fill-height" :style="`background-color: ${tablecolors.body.a}`">
                    {{ item.proforma }}
                  </div>
                </template>
                <template #forecast="{ item }">
                  <div class="pa-2 fill-height" :style="`background-color: ${tablecolors.body.b}`">
                    {{ item.forecast }}
                  </div>
                </template>
                <template #status="{ item }">
                  <status-indicator
                    :variant="item.status_variant"
                    :custom-label="item.status_label"
                    size="sm"
                  />
                </template>
              </lb-datatablenew>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <span v-if="hasSelection" class="mr-4">{{ selectedList.length }} GLs selected</span>
      <v-btn
        v-if="hasSelection"
        @click="$emit('upload')"
        color="primary"
      >
        <span>Import</span>
      </v-btn>
    </template>
  </lb-dialog>
</template>

<script>
import StatusIndicator from '../components/StatusIndicator.vue';
import { STATUS_VARIANTS } from '../utils/statusConstants';

export default {
  name: 'PreviousCycleDataDialog',
  components: {
    StatusIndicator,
  },
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    heading: { type: String, default: 'Previous Commentary Cycle List' },
    width: { type: [String, Number], default: 1200 },
    previouscycledatatoupload: { type: Array, default: () => [] },
    prevselected: { type: Array, default: () => [] },
    tablecolors: { type: Object, default: () => ({ heading: { a: '#d0dcff', b: '#efcef4' }, body: { a: '#e3f2fd', b: '#fce4ec' } }) },
    cycletype: { type: String, default: 'Actual' },
    proformaLabel: { type: String, default: 'Proforma' },
    forecastLabel: { type: String, default: 'Forecast' },
    glCodeLabel: { type: String, default: 'GL Code' },
    noDataMessage: { type: String, default: 'No data found' },
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    actualLabel() {
      return this.cycletype === 'Forecast' ? this.forecastLabel : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    previousForecastLabel() {
      return this.cycletype === 'Forecast' ? `Previous ${this.forecastLabel}` : this.forecastLabel;
    },
    selectedList() {
      return this.prevselected || [];
    },
    hasSelection() {
      return this.selectedList.length > 0;
    },
    headers() {
      return [
        { text: this.glCodeLabel, value: 'gl_code_display', sortable: false, filterable: true },
        { text: 'Description', value: 'description', sortable: false },
        {
          text: `${this.actualLabel} Vs ${this.proformaLabel}`,
          value: 'proforma',
          sortable: false,
        },
        {
          text: `${this.actualLabel} Vs ${this.previousForecastLabel}`,
          value: 'forecast',
          sortable: false,
        },
        { text: 'Status', value: 'status', sortable: false },
      ];
    },
    tableItems() {
      return this.previouscycledatatoupload.map(entry => ({
        _selectable: entry.import,
        glcode: entry.glcode,
        gl_code_display: entry.glcode_detail?.code,
        description: entry.glcode_detail?.name,
        proforma: entry.commentary1,
        forecast: entry.commentary2,
        status_variant: entry.import ? STATUS_VARIANTS.READY : STATUS_VARIANTS.COMMENTARY_NOT_IN_SCOPE,
        status_label: entry.import ? 'Ready to import' : 'Ignored',
      }));
    },
  },
  methods: {
    onSelectionChange(selectedItems) {
      this.$emit('update:selected-list', selectedItems);
    },
    syncSelection() {
      this.$nextTick(() => {
        if (this.$refs.datatable) {
          const table = this.$refs.datatable;
          table.selectItem = [...this.selectedList];
          table.selectedItem = [...this.selectedList];
        }
      });
    },
  },
  watch: {
    loading: {
      handler(val) {
        if (!val) {
          this.syncSelection();
        }
      },
      immediate: true,
    },
    previouscycledatatoupload: {
      handler(val) {
        if (val && val.length > 0 && !this.loading) {
          this.syncSelection();
        }
      },
    },
  },
};
</script>
